import { useQuery } from "@tanstack/react-query";
import { AssessmentsClient, VsemAggregateDto, VsemRecommendationStatus, VsemPublishStatus } from "@lib/ShiOneClient";
import ms from "ms";
import { ApiClientConfig } from "../../../../../../auth/ApiClientConfig";

const api = new AssessmentsClient(
  ApiClientConfig,
  import.meta.env.API_ENDPOINT
);

export function useGetTpxAssessment(assessmentId?: string) {
  return useQuery<VsemAggregateDto | null>({
    queryKey: ["tpx-assessment", assessmentId],
    enabled: Boolean(assessmentId),
    staleTime: ms("5m"),
    refetchInterval: (data) => {
      // Poll every 10 seconds while publishing or recommendation processing is in progress
      return (data?.publishStatus === VsemPublishStatus.Publishing ||
              data?.recommendationStatus === VsemRecommendationStatus.Processing)
        ? 10000
        : false;
    },
    queryFn: async () => {
      if (!assessmentId) return null;
      
      try {
        const vsem = await api.getTpxVsem(assessmentId);
        
        // Sort execution items by displayOrder
        if (vsem?.executionItems) {
          vsem.executionItems.sort((a, b) => {
            const orderA = a.displayOrder ?? 0;
            const orderB = b.displayOrder ?? 0;
            return orderA - orderB;
          });
        }
        
        return vsem;
      } catch (err: any) {
        if (err?.response?.status === 404) return null;
        throw err;
      }
    },
  });
}
